import axios from 'axios';

const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;

export type LastDayTrafficReport = {
  id: string;
  plate: string;
  createdAt: string;
};

export const getTrafficReportById = async (id: string, token: string) => {
  const { data } = await axios.get(
    `${process.env.REACT_APP_SAAB_URL}/traffic-report/${id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return data;
};

// saab scopes the search to the account in the token, so only the caller's
// own reports are returned.
export const getLastDayTrafficReportByPlate = async (
  plate: string,
  token: string,
): Promise<LastDayTrafficReport | null> => {
  const { data } = await axios.get<{ data: LastDayTrafficReport[] }>(
    `${process.env.REACT_APP_SAAB_URL}/traffic-report`,
    {
      params: {
        page: 0,
        dateSort: 'DESC',
        plate,
        createdAtAfter: new Date(Date.now() - ONE_DAY_IN_MS).toISOString(),
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return data.data[0] ?? null;
};
